// extracted by mini-css-extract-plugin
module.exports = {"container":"Blog-module--container--FrCSQ"};